import React, { useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { TableContainer, Table, TableHead, TableRow, TableBody, TableCell, Box } from "@mui/material";

// core components
import styles from "../../assets/jss/material-dashboard-react/components/tableStyle.js";
import { colors } from "../../assets/jss/material-dashboard-react";
import CustomTablePagination from "./CustomTablePagination.js";
import { getSxStyle } from "../../utils/getSxStyle.js";


export default function CustomTable(props) {
    const { tableHead, tableData, tableHeaderColor, paginationInfo, handleClick, tableRowColor, colorizeRow } = props;

    const [pageData, setPageData] = useState([]);
    const [page, setPage] = useState(0);

    useLayoutEffect(() => {
        if (paginationInfo && tableData.length > paginationInfo.pageSize) {
            setPageData(tableData.slice(0, paginationInfo.pageSize));
        } else {
            setPageData(tableData);
        }
        setPage(0);
    }, [tableData, paginationInfo]);

    const onChangePage = (event, newPage) => {
        const direction = newPage > page ? 1 : 0;
        const fromPage = direction === 1 ? page : newPage;
        const toPage = direction === 1 ? newPage : page;
        const from = (fromPage + direction) * paginationInfo.pageSize;
        const to = (toPage + direction) * paginationInfo.pageSize;
        setPageData(tableData.slice(from, tableData.length > to ? to : tableData.length));
        setPage(newPage);
    };

    let colorizeRowCondition = (param) => {
        if (colorizeRow) {
            let condition = colorizeRow(param);
            if (condition) return `${tableRowColor}TableRow`;
        }

        return "";
    };


    return (
        <Box sx={(theme) => getSxStyle(theme, styles, ['tableResponsive'])}>
            <TableContainer>
                <Table sx={(theme) => getSxStyle(theme, styles, ['table'])}>
                    {tableHead !== undefined ? (
                        <TableHead sx={(theme) => getSxStyle(theme, styles, [tableHeaderColor + "TableHeader"])}>
                            <TableRow sx={(theme) => getSxStyle(theme, styles, ['tableHeadRow'])}>
                                {tableHead.map((prop, key) => {
                                    return (
                                        <TableCell sx={(theme) => getSxStyle(theme, styles, ['tableCell', 'tableHeadCell'])} key={key}>
                                            {prop}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        </TableHead>
                    ) : null}
                    <TableBody>
                        {pageData.map((prop, key) => {
                            return (
                                <TableRow
                                    key={key}
                                    sx={(theme) => getSxStyle(theme, styles, ['tableBodyRow', `${colorizeRowCondition(prop)}`])}
                                    onClick={() => (!!handleClick ? handleClick(prop) : null)}
                                >
                                    {prop.map((prop, key) => {
                                        return (
                                            <TableCell sx={(theme) => getSxStyle(theme, styles, ['tableCell'])} key={key}>
                                                {prop}
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>

            {paginationInfo && (
                <CustomTablePagination
                    count={tableData.length}
                    page={page}
                    rowsPerPage={paginationInfo.pageSize}
                    onPageChange={onChangePage}
                />
            )}

        </Box>
    );
}

CustomTable.defaultProps = {
    tableHeaderColor: "gray",
};

CustomTable.propTypes = {
    colorizeRow: PropTypes.func,
    tableRowColor: PropTypes.oneOf(colors),
    tableHeaderColor: PropTypes.oneOf(colors),
    tableHead: PropTypes.arrayOf(PropTypes.string),
    tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
    paginationInfo: PropTypes.shape({
        pageSize: PropTypes.number,
        pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
    }),
};
